type StorageManagerWithDirectory = StorageManager & {
  getDirectory?: () => Promise<FileSystemDirectoryHandle>;
};

async function rootDirectory(): Promise<FileSystemDirectoryHandle | undefined> {
  const storage = navigator.storage as StorageManagerWithDirectory | undefined;
  return storage?.getDirectory?.();
}

async function assetsDirectory(create: boolean): Promise<FileSystemDirectoryHandle | undefined> {
  const root = await rootDirectory();
  if (!root) return undefined;
  try {
    const app = await root.getDirectoryHandle("partharbor-tools", { create });
    return await app.getDirectoryHandle("assets", { create });
  } catch (error) {
    if (!create && error instanceof DOMException && error.name === "NotFoundError") return undefined;
    throw error;
  }
}

export async function storeImmutableAsset(id: string, buffer: ArrayBuffer): Promise<"opfs" | "metadata-only"> {
  const directory = await assetsDirectory(true);
  if (!directory) return "metadata-only";
  const handle = await directory.getFileHandle(`${id}.bin`, { create: true });
  const existing = await handle.getFile();
  if (existing.size > 0) throw new Error("Immutable asset already exists.");
  const writable = await handle.createWritable();
  await writable.write(buffer);
  await writable.close();
  return "opfs";
}

export async function deleteImmutableAsset(id: string): Promise<void> {
  const directory = await assetsDirectory(false);
  if (!directory) return;
  try {
    await directory.removeEntry(`${id}.bin`);
  } catch (error) {
    if (!(error instanceof DOMException) || error.name !== "NotFoundError") throw error;
  }
}

export async function clearImmutableAssets(): Promise<void> {
  const root = await rootDirectory();
  if (!root) return;
  try {
    await root.removeEntry("partharbor-tools", { recursive: true });
  } catch (error) {
    if (!(error instanceof DOMException) || error.name !== "NotFoundError") throw error;
  }
}
